/* ===== LUNARA SHOPIFY THEME JS ===== */
(function() {
  'use strict';

  /* --- Gallery (images + video support) --- */
  function initGallery() {
    var slides = document.querySelectorAll('.gallery-slide');
    var thumbs = document.querySelectorAll('.gallery-thumb');
    var caption = document.getElementById('gallery-caption');
    if (!slides.length) return;

    function pauseAllVideos() {
      slides.forEach(function(s) {
        var v = s.querySelector('video');
        if (v) { v.pause(); }
      });
    }

    function activateSlide(idx) {
      pauseAllVideos();
      slides.forEach(function(s) { s.classList.remove('active'); });
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      slides[idx].classList.add('active');
      if (thumbs[idx]) thumbs[idx].classList.add('active');

      var slide = slides[idx];
      var mediaType = slide.getAttribute('data-media-type');

      if (mediaType === 'video') {
        var video = slide.querySelector('video');
        if (video) {
          var sources = video.querySelectorAll('source[data-src]');
          if (sources.length && !video.querySelector('source[src]')) {
            sources.forEach(function(src) {
              src.setAttribute('src', src.getAttribute('data-src'));
            });
            video.load();
          }
          video.play().catch(function() {});
        }
      }

      var img = slide.querySelector('img');
      var alt = '';
      if (img) alt = img.alt || '';
      else if (mediaType === 'video') alt = 'Product video';
      if (caption) caption.textContent = alt;
    }

    var videoSlideIdx = -1;
    slides.forEach(function(s, i) {
      if (s.getAttribute('data-media-type') === 'video') videoSlideIdx = i;
    });
    if (videoSlideIdx >= 0) {
      activateSlide(videoSlideIdx);
    } else {
      activateSlide(0);
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var idx = parseInt(this.getAttribute('data-index'));
        activateSlide(idx);
      });
    });

    var startX = 0;
    var main = document.getElementById('gallery-main');
    if (main) {
      main.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      main.addEventListener('touchend', function(e) {
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) < 40) return;
        var current = 0;
        slides.forEach(function(s, i) { if (s.classList.contains('active')) current = i; });
        if (diff > 0 && current < slides.length - 1) activateSlide(current + 1);
        else if (diff < 0 && current > 0) activateSlide(current - 1);
      }, { passive: true });
    }
  }

  /* --- Social Proof Ticker --- */
  function initTicker() {
    var el = document.getElementById('ticker-text');
    if (!el) return;
    var messages = []; /* fabricated social-proof removed */
    if (!messages.length) return;
    var index = 0;
    setInterval(function() {
      el.style.opacity = '0';
      setTimeout(function() {
        index = (index + 1) % messages.length;
        el.textContent = messages[index];
        el.style.opacity = '1';
      }, 300);
    }, 4000);
  }

  /* --- Variant Data --- */
  var variants = [];
  try {
    var jsonEl = document.getElementById('lunara-variants-json');
    if (jsonEl) variants = JSON.parse(jsonEl.textContent);
  } catch(e) {}

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    var amount = (cents / 100).toFixed(2);
    var currencySymbol = '$';
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      var c = window.Shopify.currency.active;
      var symbols = { USD:'$', AUD:'A$', GBP:'\u00A3', CAD:'C$', NZD:'NZ$', EUR:'\u20AC', SEK:'', CHF:'CHF ', DKK:'', NOK:'' };
      var suffixes = { SEK:' kr', DKK:' kr', NOK:' kr' };
      if (symbols[c] !== undefined) currencySymbol = symbols[c];
      if (suffixes[c]) return currencySymbol + amount + suffixes[c];
    }
    return currencySymbol + amount;
  }

  function updateAllPrices(variant) {
    var mainPrice = document.getElementById('main-price');
    var comparePrice = document.getElementById('compare-price');
    var afterpayAmount = document.getElementById('afterpay-amount');
    var buyBtnText = document.getElementById('buy-btn-text');
    var stickyDesktopPrice = document.getElementById('sticky-desktop-price');
    var stickyMobileText = document.getElementById('sticky-mobile-text');
    var stickyMobileBtn = document.getElementById('sticky-mobile-btn');
    var stickyDesktopCta = document.querySelector('.sticky-desktop-cta');
    var variantInput = document.getElementById('variant-id');

    var priceStr = variant.priceFormatted || formatMoney(variant.price);
    priceStr = priceStr.replace(/\.00(?=\D|$)/, '');
    var installment = formatMoney(Math.round(variant.price / 4));
    var qty = variant.quantity || 1;
    var cartUrl = '/cart/' + variant.id + ':' + qty;

    if (mainPrice) mainPrice.textContent = priceStr;
    if (afterpayAmount) afterpayAmount.textContent = installment;
    if (buyBtnText) buyBtnText.textContent = 'Get Yours \u2014 ' + priceStr + ' \u00B7 Free Shipping';
    if (stickyDesktopPrice) stickyDesktopPrice.textContent = priceStr;
    if (stickyMobileText) stickyMobileText.textContent = 'Buy Now \u2014 ' + priceStr;
    if (stickyMobileBtn) stickyMobileBtn.href = cartUrl;
    if (stickyDesktopCta) stickyDesktopCta.href = cartUrl;
    if (variantInput) variantInput.value = variant.id;

    if (comparePrice) {
      if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
        comparePrice.textContent = variant.compareAtPriceFormatted || formatMoney(variant.compareAtPrice);
        comparePrice.style.display = '';
      } else {
        comparePrice.style.display = 'none';
        comparePrice.textContent = '';
      }
    }
  }

  /* --- Bundle Options --- */
  function initBundleOptions() {
    var options = document.querySelectorAll('.bundle-option');
    options.forEach(function(opt) {
      opt.addEventListener('click', function() {
        options.forEach(function(o) { o.classList.remove('active'); });
        this.classList.add('active');

        var variantId = this.getAttribute('data-variant-id');
        if (variantId) {
          var variant = variants.find(function(v) { return String(v.id) === String(variantId); });
          if (variant) {
            updateAllPrices(variant);
          } else {
            var input = document.getElementById('variant-id');
            if (input) input.value = variantId;
          }
        }
      });
    });
  }

  /* --- Add to Cart (Shopify AJAX API) --- */
  function initAddToCart() {
    var form = document.getElementById('product-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var variantId = document.getElementById('variant-id').value;
      var quantity = document.getElementById('variant-qty') ? document.getElementById('variant-qty').value : '1';
      var btn = document.getElementById('buy-now-button');
      var btnText = document.getElementById('buy-btn-text');

      if (!variantId) {
        alert('Please select an option.');
        return;
      }

      var originalText = btnText ? btnText.textContent : '';
      if (btnText) btnText.textContent = 'Adding to cart...';
      if (btn) { btn.disabled = true; btn.classList.add('btn-processing'); }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(quantity) || 1 })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function() {
        if (btnText) btnText.textContent = originalText;
        if (btn) { btn.disabled = false; btn.classList.remove('btn-processing'); }
        if (window.LunaraCart) window.LunaraCart.open();
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
        if (btnText) btnText.textContent = originalText;
        if (btn) { btn.disabled = false; btn.classList.remove('btn-processing'); }
        alert('Something went wrong. Please try again.');
      });
    });
  }

  /* --- FAQ Accordion --- */
  function initFAQ() {
    var questions = document.querySelectorAll('.faq-question');
    questions.forEach(function(q) {
      q.addEventListener('click', function() {
        var item = this.closest('.faq-item');
        var wasOpen = item.classList.contains('open');
        document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
    });
  }

  /* --- Sticky Bars --- */
  function initStickyBars() {
    var desktopBar = document.getElementById('sticky-desktop-bar');
    var mobileBar = document.getElementById('sticky-mobile-bar');
    if (!desktopBar && !mobileBar) return;

    var configEl = document.getElementById('sticky-bar-config');
    var trigger = configEl ? configEl.getAttribute('data-trigger') : 'after_product';

    function showBars() {
      if (desktopBar) desktopBar.classList.add('visible');
      if (mobileBar) mobileBar.classList.add('visible');
    }
    function hideBars() {
      if (desktopBar) desktopBar.classList.remove('visible');
      if (mobileBar) mobileBar.classList.remove('visible');
    }

    if (trigger === 'always') {
      showBars();
      return;
    }

    if (trigger === 'after_half') {
      window.addEventListener('scroll', function() {
        var scrollPercent = window.pageYOffset / (document.documentElement.scrollHeight - window.innerHeight);
        if (scrollPercent >= 0.5) showBars();
        else hideBars();
      }, { passive: true });
      return;
    }

    var buySection = document.getElementById('buy');
    if (!buySection) return;

    var observer = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) showBars();
          else hideBars();
        });
      },
      { threshold: 0, rootMargin: '-1px 0px 0px 0px' }
    );

    observer.observe(buySection);
  }

  /* --- Luna Chat --- */
  function initLunaChat() {
    /* removed: lamp-era feature, not used by The 1986 Collection */
    return;
  }

  /* --- Spin Wheel with promo code + email capture --- */
  function initSpinWheel() {
    /* removed: lamp-era feature, not used by The 1986 Collection */
    return;
  }


  /* --- Delivery window estimate (5-10 business days ~ 7-12 calendar) --- */
  function initDeliveryEstimate() {
    var box = document.getElementById('delivery-estimate');
    var win = document.getElementById('delivery-window');
    if (!box || !win) return;
    try {
      var fmt = new Intl.DateTimeFormat(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
      var a = new Date(); a.setDate(a.getDate() + 7);
      var b = new Date(); b.setDate(b.getDate() + 12);
      win.textContent = fmt.format(a) + ' \u2013 ' + fmt.format(b);
      box.hidden = false;
    } catch (e) { /* leave hidden */ }
  }

  /* --- Tab Title Animation --- */
  function initTabTitle() {
    /* disabled: legacy tab-title rotation overwrote the real page title
       (bad for SEO and showed outdated product wording) */
    return;
  }

  /* --- Init All --- */
  function initVideoPerformance() {
    var videos = document.querySelectorAll('.gallery-video');
    if (!videos.length) return;

    if ('connection' in navigator) {
      var conn = navigator.connection;
      if (conn.saveData || conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g') {
        videos.forEach(function(v) {
          v.removeAttribute('autoplay');
          v.preload = 'none';
          v.pause();
        });
        return;
      }
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      videos.forEach(function(v) {
        v.removeAttribute('autoplay');
        v.pause();
      });
      return;
    }

    videos.forEach(function(v) {
      v.play().catch(function() {});
    });
  }

  function fixDynamicCheckoutOverflow() {
    function constrain() {
      var targets = document.querySelectorAll(
        '.shopify-payment-button, .shopify-cleanslate, [data-shopify-buttoncontainer], shopify-accelerated-checkout, shopify-accelerated-checkout-cart, shopify-payment-terms'
      );
      targets.forEach(function(el) {
        el.style.maxWidth = '100%';
        el.style.width = '100%';
        el.style.boxSizing = 'border-box';
        el.style.overflow = 'hidden';
      });
      var iframes = document.querySelectorAll('.shopify-payment-button iframe, .shopify-cleanslate iframe, .express-checkout-wrapper iframe');
      iframes.forEach(function(el) {
        el.style.maxWidth = '100%';
        el.style.width = '100%';
        el.style.boxSizing = 'border-box';
      });
    }
    constrain();
    setTimeout(constrain, 500);
    setTimeout(constrain, 1500);
    setTimeout(constrain, 3000);
    var observer = new MutationObserver(function(mutations) {
      var dominated = false;
      mutations.forEach(function(m) {
        if (m.addedNodes.length && !dominated) {
          dominated = true;
          setTimeout(constrain, 100);
        }
      });
    });
    var form = document.getElementById('product-form');
    if (form) {
      observer.observe(form, { childList: true, subtree: true });
    }
    var wrapper = document.querySelector('.express-checkout-wrapper');
    if (wrapper) {
      observer.observe(wrapper, { childList: true, subtree: true });
    }
  }

  function initExpressCheckoutFix() {
    var PAYMENT_TIMEOUT = 30000;

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.shopify-payment-button__button');
      if (!btn) return;

      if (btn.classList.contains('processing')) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      btn.classList.add('processing');

      var timeoutId = setTimeout(function() {
        btn.classList.remove('processing');
        var existing = btn.parentElement.querySelector('.payment-error');
        if (existing) existing.remove();
        var errorDiv = document.createElement('div');
        errorDiv.className = 'payment-error';
        errorDiv.textContent = 'Payment is taking longer than expected. Please try again.';
        btn.parentElement.appendChild(errorDiv);
        setTimeout(function() { errorDiv.remove(); }, 8000);
      }, PAYMENT_TIMEOUT);

      setTimeout(function() {
        btn.classList.remove('processing');
      }, 5000);

      window.addEventListener('pagehide', function() {
        clearTimeout(timeoutId);
      }, { once: true });
    }, true);
  }


  /* --- Cart Drawer (slides in from the right; no standalone cart page) --- */
  function initCartDrawer() {
    var drawer  = document.getElementById('cd-drawer');
    var overlay = document.getElementById('cd-overlay');
    if (!drawer || !overlay) return;

    var itemsEl = document.getElementById('cd-items');
    var emptyEl = document.getElementById('cd-empty');
    var footEl  = document.getElementById('cd-foot');
    var subEl   = document.getElementById('cd-subtotal');
    var countEl = document.getElementById('cart-count');
    var ckBtn   = document.getElementById('cd-checkout');
    var ckText  = document.getElementById('cd-checkout-text');
    var lastFocus = null;

    var cartCurrency = 'USD';
    function money(cents) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency', currency: cartCurrency,
          minimumFractionDigits: (cents % 100 === 0 ? 0 : 2)
        }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
      }
    }

    function render(cart) {
      itemsEl.innerHTML = '';
      var has = cart.items && cart.items.length > 0;
      emptyEl.hidden = has;
      footEl.hidden  = !has;

      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.hidden = cart.item_count === 0;
      }

      (cart.items || []).forEach(function(item) {
        var li = document.createElement('li');
        li.className = 'cd-item';
        var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
        li.innerHTML =
          '<div class="cd-thumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
          '<div class="cd-info">' +
            '<p class="cd-name">' + item.product_title + '</p>' +
            (item.variant_title ? '<p class="cd-variant">' + item.variant_title + '</p>' : '') +
            '<div class="cd-qty" data-key="' + item.key + '">' +
              '<button type="button" class="cd-q" data-delta="-1" aria-label="Decrease quantity">&minus;</button>' +
              '<span class="cd-qn">' + item.quantity + '</span>' +
              '<button type="button" class="cd-q" data-delta="1" aria-label="Increase quantity">+</button>' +
              '<button type="button" class="cd-remove" data-key="' + item.key + '">Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="cd-price">' + money(item.final_line_price) +
            (item.original_line_price > item.final_line_price
              ? '<s class="cd-was">' + money(item.original_line_price) + '</s>' : '') +
          '</div>';
        itemsEl.appendChild(li);
      });

      if (subEl) subEl.textContent = money(cart.total_price);

      /* --- Bundle progress: Buy 3, save 15% (matches the real automatic discount) --- */
      var bEl = document.getElementById('cd-bundle');
      var bMsg = document.getElementById('cd-bundle-msg');
      var bFill = document.getElementById('cd-bundle-fill');
      if (bEl && bMsg && bFill) {
        var n = cart.item_count || 0;
        var need = 3 - n;
        bEl.hidden = (n === 0);
        bFill.style.width = Math.min(100, Math.round((n / 3) * 100)) + '%';
        if (need > 0) {
          bMsg.innerHTML = 'Add <strong>' + need + '</strong> more item' + (need > 1 ? 's' : '') + ' to save <strong>15%</strong>';
          bEl.classList.remove('is-unlocked');
        } else {
          var saved = cart.total_discount ? ' \u2014 you saved ' + money(cart.total_discount) : '';
          bMsg.innerHTML = '\uD83C\uDF89 <strong>15% off unlocked</strong>' + saved;
          bEl.classList.add('is-unlocked');
        }
      }
      if (ckText) ckText.textContent = 'Checkout \u00B7 ' + money(cart.total_price);
    }

    function refresh() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(c) { if (c && c.currency) cartCurrency = c.currency; render(c); })
        .catch(function(e) { console.error('cart refresh failed', e); });
    }

    function open() {
      lastFocus = document.activeElement;
      overlay.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cd-open');
      requestAnimationFrame(function() {
        overlay.classList.add('is-on');
        drawer.classList.add('is-on');
      });
      refresh();
      var c = document.getElementById('cd-close');
      if (c) c.focus();
    }

    function close() {
      overlay.classList.remove('is-on');
      drawer.classList.remove('is-on');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cd-open');
      setTimeout(function() { overlay.hidden = true; }, 260);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function change(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function(r) { return r.json(); }).then(render);
    }

    document.addEventListener('click', function(e) {
      var opener = e.target.closest('[data-cd-open]');
      if (opener) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-cd-close]') || e.target.id === 'cd-close') { e.preventDefault(); close(); return; }
      if (e.target === overlay) { close(); return; }

      var q = e.target.closest('.cd-q');
      if (q) {
        var wrap = q.closest('.cd-qty');
        var n = parseInt(wrap.querySelector('.cd-qn').textContent, 10) || 1;
        change(wrap.getAttribute('data-key'), Math.max(0, n + parseInt(q.getAttribute('data-delta'), 10)));
        return;
      }
      var rm = e.target.closest('.cd-remove');
      if (rm) { change(rm.getAttribute('data-key'), 0); return; }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-on')) close();
    });

    if (ckBtn) {
      ckBtn.addEventListener('click', function() {
        var code = sessionStorage.getItem('lunara_discount_code');
        ckBtn.disabled = true;
        window.location.href = code
          ? '/discount/' + encodeURIComponent(code) + '?redirect=/checkout'
          : '/checkout';
      });
    }

    window.LunaraCart = { open: open, close: close, refresh: refresh };
  }

  function init() {
    initGallery();
    initVideoPerformance();
    initTicker();
    initBundleOptions();
    initAddToCart();
    initCartDrawer();
    initDeliveryEstimate();
    initFAQ();
    initStickyBars();
    initLunaChat();
    initSpinWheel();
    initTabTitle();
    fixDynamicCheckoutOverflow();
    initExpressCheckoutFix();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* --- wl-header-offset: keep page content out from under the fixed announcement bar + navbar --- */
(function () {
  function setHeaderOffset() {
    var main = document.querySelector('main');
    if (!main) return;
    var bottom = 0;
    ['.announcement-bar', '.navbar'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      var s = window.getComputedStyle(el);
      if (s.position === 'fixed' && s.display !== 'none' && el.offsetHeight) {
        bottom = Math.max(bottom, el.getBoundingClientRect().bottom);
      }
    });
    main.style.paddingTop = bottom > 0 ? Math.round(bottom) + 'px' : '';
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setHeaderOffset);
  } else {
    setHeaderOffset();
  }
  window.addEventListener('load', setHeaderOffset);
  window.addEventListener('resize', setHeaderOffset);
})();
